var map = {
	"./base": "2db0",
	"./base.js": "2db0",
	"./jwt": "9745",
	"./jwt.js": "9745",
	"./mfa": "b204",
	"./mfa.js": "b204",
	"./oAuth2": "aac3",
	"./oAuth2.js": "aac3",
	"./settings": "0781",
	"./settings.js": "0781"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7905";